module.exports = __webpack_public_path__ + "img/ClickForSound_4.aac53251.png";